function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMenuLifecycle = function SvgMenuLifecycle(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    overflow: "hidden",
    height: 36,
    width: 60,
    ref: svgRef
  }, props), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    style: {
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      stroke: "none",
      fill: "#feffff",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 12.327082,16.692425 C 13.006448,8.6710568 19.51283,2.5169738 27.312919,2.5169738 v 6.8140383 c -4.27321,0 -7.835998,3.4647649 -8.198973,7.9747829 z"
  }), React.createElement("path", {
    d: "M 12.327082,16.692424 C 13.006448,8.6710564 19.51283,2.5169734 27.312919,2.5169734 v 6.8140387 c -4.27321,0 -7.835998,3.4647639 -8.198973,7.9747819 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#feffff",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 29.340341,0.57592886 V 2.6916678 l 2.455422,0.4551751 c 6.146319,1.7527636 10.560255,7.3662651 10.560255,13.9279681 h -6.616052 c 0,-3.076556 -1.774115,-5.771697 -4.398408,-7.0828731 L 29.340341,9.4261233 V 11.690352 L 22.945568,6.1331405 Z"
  }), React.createElement("path", {
    d: "m 28.984323,0.5011183 v 2.115739 l 2.455422,0.4551751 C 37.586064,4.824796 42,10.438297 42,17 h -6.616052 c 0,-3.076556 -1.774115,-5.771697 -4.398408,-7.0828726 L 28.984323,9.3513128 V 11.615541 L 22.58955,6.05833 Z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    className: "icon-primary",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 49.088055,0.57592901 V 2.6918621 L 46.510202,3.1466489 C 40.0568,4.8991214 35.421876,10.512798 35.421876,17.074811 h 6.947 c 0,-3.076653 1.862724,-5.772192 4.617891,-7.0832321 l 2.101288,-0.5658437 v 2.2645688 l 6.714793,-5.5571633 z"
  }), React.createElement("path", {
    d: "M 49.088055,0.5759289 V 2.691862 L 46.510202,3.1466488 C 40.0568,4.8991213 35.421876,10.512798 35.421876,17.074811 h 6.947 c 0,-3.076653 1.862724,-5.772192 4.617891,-7.0832318 l 2.101288,-0.565844 v 2.2645688 l 6.714793,-5.5571634 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#feffff",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 45.267585,18.937243 H 43.027619 L 42.54527,21.514951 C 40.689631,27.967955 34.746151,32.60317 27.798181,32.60317 v -6.946999 c 3.258044,0 6.11138,-1.862433 7.500197,-4.617746 l 0.598813,-2.101182 H 33.49903 l 5.884277,-6.715045 z"
  }), React.createElement("path", {
    d: "M 45.267585,18.937243 H 43.027619 L 42.54527,21.514951 C 40.689631,27.967955 34.746151,32.60317 27.798181,32.60317 v -6.946999 c 3.258044,0 6.11138,-1.862433 7.500197,-4.617746 l 0.598813,-2.101182 H 33.49903 l 5.884277,-6.715045 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fill: "#feffff",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#adb9ca",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 25.935748,35.514738 V 33.274772 L 23.35804,32.792422 C 16.905036,30.937754 12.269821,24.993304 12.269821,18.045333 h 6.947 c 0,3.258044 1.862433,6.11138 4.617746,7.500198 l 2.101181,0.598812 v -2.39719 l 6.715045,5.883307 z"
  }), React.createElement("path", {
    d: "M 25.935748,35.514738 V 33.274772 L 23.35804,32.792422 C 16.905036,30.937754 12.269821,24.993304 12.269821,18.045333 h 6.947 c 0,3.258044 1.862433,6.11138 4.617746,7.500198 l 2.101181,0.598812 v -2.39719 l 6.715045,5.883307 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#adb9ca",
    fillRule: "evenodd",
    style: {
      display: "inline",
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })), React.createElement("g", {
    style: {
      display: "inline"
    }
  }, React.createElement("path", {
    className: "icon-secondary",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      fillOpacity: 1
    },
    fillRule: "evenodd",
    fill: "#ecaec6",
    strokeMiterlimit: 10,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 0.666667,
    stroke: "#002060",
    d: "M 21.975046,16.183153 H 19.734692 L 19.253119,13.6053 C 17.39748,7.1518983 11.45366,2.5169741 4.5056422,2.5169741 V 9.463974 c 3.2576266,0 6.1117378,1.862724 7.4998958,4.617891 l 0.599133,2.101288 h -2.397783 l 5.884074,6.714793 z"
  }), React.createElement("path", {
    d: "M 21.975046,16.183153 H 19.734692 L 19.253119,13.6053 C 17.39748,7.1518983 11.45366,2.5169741 4.5056422,2.5169741 V 9.463974 c 3.2576266,0 6.1117378,1.862724 7.4998958,4.617891 l 0.599133,2.101288 h -2.397783 l 5.884074,6.714793 z",
    stroke: "#002060",
    strokeWidth: 0.666667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    fill: "#ecaec6",
    fillRule: "evenodd",
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    className: "icon-tertiary"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuLifecycle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menu-lifecycle.6d39639e.svg";
export { ForwardRef as ReactComponent };